import PlainAccordion from './plain-accordion'


export default PlainAccordion
